import React, { useState } from 'react'

import './ButtonSection.css'

const ButtonSection = ({sections}) => {
    const [section, setSection] = useState(Object.keys(sections)[0])

    return (
        <div className="button-section">
            <div className="buttons">
                {Object.keys(sections).map((key) => {
                    return <button 
                            className={key === section ? "on sec" : "off sec"}
                            onClick={() => setSection(key)}
                        >
                        {key}
                    </button>
                })}
            </div>
            <div className="sec-content">
                {sections[section]}
            </div>
        </div>
    )
}

export default ButtonSection